import {
    Component,
    Element,
    Host,
    Listen,
    Prop,
    State,
    h,
} from "@stencil/core";

/**
 * HotSpot component that can be placed on an image
 */
@Component({
    tag: "ux-iws-hot-spot-info",
    styleUrl: "hot-spot-info.scss",
    shadow: true,
})
export class HotSpotInfo {
    @Element() element: HTMLUxIwsHotSpotInfoElement;

    /**
     * unique identifier for the hot spot
     */
    @Prop() hotSpotId: string;

    @State() active: boolean = false;

    @Listen("uxActiveHotSpotChange", { target: "body" })
    activeHotSpotChange(event: CustomEvent) {
        if (event.detail.activeHotSpot === this.hotSpotId) {
            this.active = true;
        } else {
            this.active = false;
        }
    }

    private handleClick(e: MouseEvent) {
        const link = (e.target as HTMLElement).closest("a");
        if (link && link.getAttribute("href").startsWith("#")) {
            e.preventDefault();
            document
                .querySelector(link.getAttribute("href"))
                .scrollIntoView({ behavior: "smooth" });
        }
    }

    componentWillLoad() {
        this.active =
            this.element.closest("ux-iws-hot-spot-container")?.activeHotSpot ===
            this.hotSpotId;
    }

    render() {
        const { active } = this;
        return (
            <Host
                {...{ active }}
                aria-hidden={!active}
                onClick={this.handleClick.bind(this)}
            >
                <slot></slot>
            </Host>
        );
    }
}
